import React, { useState, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { TournamentProvider } from 'context/TournamentContext';
import { useTournament } from 'context/TournamentContext';
import FullPageLoad from 'components/ui/FullPageLoad';
import Dashboard from 'screens/Authenticated/Game';
import StatusTournament from 'screens/Authenticated/StatusTournament';
import TournamentWaiting from 'screens/Authenticated/TournamentWaiting';
import OverpaymentModal from 'components/ui/OverpaymentModal/OverpaymentModal';
import { deriveTournamentPhase } from 'utils/tournamentPhase';


export const TournamentWrapper = ({ children, disableTournamentContext = false, loadTradingPairs = true }) => {
  const { id } = useParams();
  const location = useLocation();

  if (disableTournamentContext) {
    return <>{children}</>;
  }

  const tournamentId = id ? Number(id) : 87;
  const initialTournamentDetails = location?.state?.tournamentDetails ?? null;
  const providerKey = `${tournamentId}:${location?.pathname ?? ''}`;

  return (
    <TournamentProvider
      key={providerKey}
      tournamentId={tournamentId}
      loadTradingPairs={loadTradingPairs}
      initialTournamentDetails={initialTournamentDetails}
    >
      {children}
    </TournamentProvider>
  );
};

export const GameRouter = () => {
    const { tournamentStatus, joinedStatus, tournamentId, tournamentDetails } = useTournament();
    const [overpaymentData, setOverpaymentData] = useState(null);

    // Detect overpayment data from localStorage (persisted by PaymentQR on OVERPAID)
    useEffect(() => {
      if (!tournamentId) return;
      try {
        const key = `overpayment_${tournamentId}`;
        const stored = localStorage.getItem(key);
        if (stored) {
          const data = JSON.parse(stored);
          if (data && data.paidAmount > data.expectedAmount) {
            setOverpaymentData(data);
          }
          localStorage.removeItem(key);
        }
      } catch { /* corrupted data — ignore */ }
    }, [tournamentId]);

    const handleCloseOverpayment = () => {
      setOverpaymentData(null);
    };

    if (joinedStatus === null) {
      return <FullPageLoad />;
    }

    const rawData = tournamentDetails?.data;
    const attributes = rawData?.attributes ?? rawData?.data ?? rawData ?? {};
    const endAt = attributes?.end_at ?? attributes?.endDate;
    const phase = deriveTournamentPhase(tournamentStatus, endAt);

    const canShowDashboard =
      !!joinedStatus &&
      (phase === 'TRADING' || phase === 'FINALIZING' || phase === 'FINISHED' || phase === 'CANCELLED');
    const isWaitingForStart = !!joinedStatus && phase === 'WAITING';

    console.log('[GameRouter] render decision', {
      tournamentId,
      tournamentStatus,
      joinedStatus,
      phase,
      canShowDashboard,
      isWaitingForStart,
    });

    let content;
    // FullPageLoad only while status is still hydrating (null). Once we have a
    // backend status we don't recognize (e.g. waiting_for_start,
    // waiting_for_opponent, pending_payment), fall back to StatusTournament —
    // that's the pre-existing default branch and avoids stranding users on an
    // infinite spinner.
    if (phase === 'UNKNOWN' && tournamentStatus == null) {
      content = <FullPageLoad />;
    } else if (canShowDashboard) {
      content = <Dashboard />;
    } else if (isWaitingForStart) {
      content = <TournamentWaiting />;
    } else {
      content = <StatusTournament />;
    }

    return (
      <>
        {content}
        {overpaymentData && (
          <OverpaymentModal data={overpaymentData} onClose={handleCloseOverpayment} />
        )}
      </>
    );
  };
